import { createRoot } from "react-dom/client";
import { ErrorBoundary } from "./components/ErrorBoundary";
import "./index.css";
const root = createRoot(document.getElementById("root")!);
if (
  !import.meta.env.VITE_SUPABASE_URL ||
  !import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY
) {
  root.render(
    <main className="mx-auto max-w-lg p-8 pt-24">
      <h1 className="text-2xl font-semibold">
        Workshop configuration is missing
      </h1>
      <p className="mt-3 text-sm text-muted-foreground">
        Contact your administrator to restore the application configuration.
      </p>
    </main>,
  );
} else {
  import("./App")
    .then(({ default: App }) =>
      root.render(
        <ErrorBoundary>
          <App />
        </ErrorBoundary>,
      ),
    )
    .catch(() =>
      root.render(
        <main className="p-8">
          Unable to load the application. Please reload this page.
        </main>,
      ),
    );
}
